// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {PlayerType, RecorderMapping, TrainingRoom} from "@models";
import {SimEnumExtendedService, NotificationService, SimSystemExtendedService} from "@services";
import {SimTrainingRoomService} from "@services";
import Enumerable from "linq";
import {Translations} from "@translations";

export interface DialogData_RoomRecorderSelectionDialogInput extends MatDialogDataBaseInput {
	trainingRoom: TrainingRoom;
}

export interface DialogData_RoomRecorderSelectionDialogOutput extends MatDialogDataBaseOutput {
	updatedTrainingRoom?: TrainingRoom;
}

@Component({
	selector: "sim-room-recorder-selection-dialog",
	templateUrl: "./room-recorder-selection-dialog.component.html",
	styleUrls: ["./room-recorder-selection-dialog.component.scss"],
	standalone: false,
})
export class RoomRecorderSelectionDialogComponent extends BasicMaterialDialog<
	RoomRecorderSelectionDialogComponent,
	DialogData_RoomRecorderSelectionDialogInput,
	DialogData_RoomRecorderSelectionDialogOutput
> {
	T = Translations;
	public selectedRecorderId: string = null;

	recorderList: Enumerable.IDictionary<string, RecorderMapping> = null;
	public availableRecorderList: RecorderMapping[] = null;
	public usedRecorderList: RecorderMapping[] = null;

	constructor(
		_injector: Injector,
		private _simSystemService: SimSystemExtendedService,
	) {
		super(_injector);
	}

	public ngOnInit() {
		super.ngOnInit();

		this._simSystemService.getRecorderMappings().then((result) => {
			this.recorderList = Enumerable.from(result).toDictionary(
				(recorder) => recorder.id,
				(recorder) => recorder,
			);
		});
	}

	ok() {
		this.selectedRecorderId = null;
		this.availableRecorderList = null;
		this.usedRecorderList = null;
		this.close({action: "ok", updatedTrainingRoom: this.data.trainingRoom});
	}

	public filterAvailableRecorderList() {
		if (!!this.recorderList && !!this.data?.trainingRoom?.recorderMappingIds) {
			this.availableRecorderList = this.recorderList
				.toEnumerable()
				.where((recorder) => !this.data.trainingRoom.recorderMappingIds.includes(recorder.value.id))
				.select((r) => r.value)
				.toArray();
		}
		return this.availableRecorderList;
	}

	public filterUsedRecorderList() {
		if (!!this.recorderList && !!this.data?.trainingRoom?.recorderMappingIds) {
			this.usedRecorderList = this.recorderList
				.toEnumerable()
				.where((recorder) => this.data.trainingRoom.recorderMappingIds.includes(recorder.value.id))
				.select((r) => r.value)
				.toArray();
		}
		return this.usedRecorderList;
	}

	public addRecorder(recorderId: string, recorderIds: string[]) {
		if (recorderIds.indexOf(recorderId) < 0) {
			recorderIds.push(recorderId);
			this.resetFilters();
		}
	}

	public removeRecorder(recorder: RecorderMapping) {
		this.data.trainingRoom.recorderMappingIds.splice(this.data.trainingRoom.recorderMappingIds.indexOf(recorder.id), 1);
		this.resetFilters();
	}

	private resetFilters() {
		this.availableRecorderList = null;
		this.usedRecorderList = null;
	}

	public getRecorderName(recorder: RecorderMapping): string {
		return recorder.name;
	}
}
